import styled from 'styled-components';
import { Container as SemanticContainer } from 'semantic-ui-react';

export const Container = styled(SemanticContainer)`
  &.ui.container {
    background-color: white;
    border-radius: 5px;
    padding: 15px;
    position: absolute;
    width: 300px;
    z-index: 12;
  }
`;
